import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-shadow-sm tw-shadow-slate-900/5 tw-p-4" }
const _hoisted_2 = { class: "tw-flex tw-items-start tw-justify-between tw-gap-3" }
const _hoisted_3 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_4 = { class: "tw-text-base tw-font-semibold tw-text-slate-900" }
const _hoisted_5 = {
  key: 0,
  class: "tw-mt-3"
}
const _hoisted_6 = {
  key: 0,
  class: "tw-text-sm tw-text-slate-700"
}
const _hoisted_7 = { class: "tw-font-medium tw-text-slate-900" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "uk-flex uk-width-1-1"
}
const _hoisted_10 = {
  key: 2,
  class: "uk-flex uk-width-1-1"
}
const _hoisted_11 = {
  key: 3,
  class: "tw-mt-3 tw-w-full sm:tw-max-w-sm"
}
const _hoisted_12 = { class: "tw-flex tw-h-10 tw-w-full tw-items-center tw-overflow-hidden tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/70 tw-backdrop-blur" }
const _hoisted_13 = { class: "tw-min-w-0 tw-flex-1" }
const _hoisted_14 = { key: 4 }
const _hoisted_15 = { class: "uk-margin-remove-left uk-margin-remove-bottom uk-margin-top" }
const _hoisted_16 = {
  key: 0,
  class: "uk-margin-remove"
}
const _hoisted_17 = {
  key: 1,
  class: "uk-margin-remove"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_CopyButton = _resolveComponent("CopyButton")!
  const _component_EditCustomer = _resolveComponent("EditCustomer")!
  const _component_filterable_dropdown = _resolveComponent("filterable-dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CustomerDetails = _resolveComponent("CustomerDetails")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_font_awesome_icon, {
            icon: "location-dot",
            class: "tw-h-4 tw-w-4 tw-text-slate-500"
          }),
          _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.receiverText), 1),
          (_ctx.receiverCopyValue)
            ? (_openBlock(), _createBlock(_component_CopyButton, {
                key: 0,
                value: _ctx.receiverCopyValue,
                title: "Copy location",
                ariaLabel: "Copy location"
              }, null, 8, ["value"]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.editable)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "tw-inline-flex tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/70 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 hover:tw-bg-white",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleEditingCustomer && _ctx.toggleEditingCustomer(...args))),
              title: "Edit"
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "pen-to-square" })
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.order.receiver)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (!_ctx.isEditingCustomer)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.order.receiver.name), 1),
                  (
            _ctx.order.receiver.deliveryAddress &&
            _ctx.order.receiver.deliveryAddress.streetAddress
          )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.addressLine2(_ctx.order.receiver.deliveryAddress)), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, _toDisplayString(_ctx.addressLine3(_ctx.order.receiver.deliveryAddress)), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isEditingCustomer)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_EditCustomer, {
                    orderId: _ctx.order.id,
                    currentCustomerId: _ctx.order.receiver && _ctx.order.receiver.id,
                    currentCustomer: _ctx.order.receiver,
                    onSaveCustomer: _ctx.saveCustomer,
                    onCancelCustomerEdit: _ctx.cancelEditingCustomer
                  }, null, 8, ["orderId", "currentCustomerId", "currentCustomer", "onSaveCustomer", "onCancelCustomerEdit"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_10)),
            (_ctx.showReceivingContactDropdown)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_filterable_dropdown, {
                        class: "tw-w-full tw-min-w-0",
                        options: _ctx.order.receiver.contacts,
                        label: "name",
                        inPill: true,
                        onInput: _ctx.setReceivingContact
                      }, null, 8, ["options", "onInput"])
                    ]),
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "tw-my-2 tw-w-px tw-bg-slate-200/70" }, null, -1)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "tw-inline-flex tw-h-10 tw-shrink-0 tw-items-center tw-justify-center tw-px-3 tw-text-slate-700 hover:tw-bg-white",
                      title: "Cancel",
                      "aria-label": "Cancel",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleAddReceivingContact && _ctx.toggleAddReceivingContact(...args)))
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: "xmark" })
                    ])
                  ])
                ]))
              : (_ctx.order.receivingContact)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.order.receivingContact.name), 1),
                    (_ctx.order.receivingContact.email)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.order.receivingContact.email), 1))
                      : _createCommentVNode("", true),
                    (_ctx.order.receivingContact.phoneNumber)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.order.receivingContact.phoneNumber), 1))
                      : _createCommentVNode("", true)
                  ]))
                : (!_ctx.isEditingCustomer && _ctx.showEditContact)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 5,
                      type: "button",
                      class: "tw-mt-3 tw-inline-flex tw-h-10 tw-items-center tw-justify-center tw-gap-2 tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/70 tw-px-3 tw-text-sm tw-font-semibold tw-text-slate-700 hover:tw-bg-white",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleAddReceivingContact && _ctx.toggleAddReceivingContact(...args))),
                      title: "Add contact",
                      "aria-label": "Add contact"
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: "plus" }),
                      _cache[5] || (_cache[5] = _createElementVNode("span", null, "Add Contact", -1))
                    ]))
                  : _createCommentVNode("", true),
            (!_ctx.isEditingCustomer && _ctx.showDetails)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 6,
                  onClick: _ctx.showCustomerDetails,
                  isDefault: true,
                  class: "uk-margin-small-top uk-margin-small-left"
                }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode("Details", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isCustomerDetailsOpen)
      ? (_openBlock(), _createBlock(_component_CustomerDetails, {
          key: 0,
          isOpen: _ctx.isCustomerDetailsOpen,
          "onUpdate:isOpen": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isCustomerDetailsOpen) = $event)),
          customerId: _ctx.order?.receiver?.id
        }, null, 8, ["isOpen", "customerId"]))
      : _createCommentVNode("", true)
  ], 64))
}